import React from 'react';
import { JOB_DRAFT_EDIT } from 'misc/constants';
import { NumberOrIdLinkFieldCellRenderer } from 'misc/cellRenderers';
import { dateFormatter, datetimeFormatter } from 'misc/cellFormatters';
import ListTable from 'components/core/ListTable';
import PureRenderComponent from 'components/core/PureRenderComponent';


class JobdDraftListTable extends PureRenderComponent {
  constructor(props) {
    super(props);
    this.state = {
      columnDefs: [
        {
          headerName: 'NO./ID',
          field: 'id',
          pinned: 'left',
          cellClass: 'ag-jobNumber',
          width: 140,
          cellRendererFramework: NumberOrIdLinkFieldCellRenderer,
          cellRendererParams: {
            handleTabOpen: this.props.handleTabOpen,
            tab: JOB_DRAFT_EDIT,
          },
        },
        {
          headerName: 'Client',
          field: 'client.name',
          width: 200,
        },
        {
          headerName: 'Deadline',
          field: 'deadline',
          width: 150,
          valueFormatter: datetimeFormatter,
        },
        {
          headerName: 'AE Subject',
          field: 'aeSubject',
          width: 300,
        },
        {
          headerName: 'Type',
          field: 'type',
          width: 65,
        },
        {
          headerName: 'Service',
          field: 'service.name',
          width: 80,
        },
        {
          headerName: 'Lv',
          field: 'level',
          width: 40,
        },
        {
          headerName: 'Receive Date',
          field: 'receiveDate',
          width: 110,
          valueFormatter: dateFormatter,
        },
        {
          headerName: 'AE',
          field: 'ae.name',
          width: 80,
        },
        {
          headerName: 'Coordinator',
          field: 'coordinator.name',
          width: 120,
        }
      ]
    }
  }

  render() {
    return (
      <ListTable
        rowData={this.props.jobs}
        columnDefs={this.state.columnDefs}
        deltaRowDataMode={true}
        getRowNodeId={data => data.id} />
    );
  }
}

export default JobdDraftListTable;
